(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('slide-gradient-controller')) {
customElements.define('slide-gradient-controller', class extends HTMLElement {
  connectedCallback() { queueMicrotask(() => { if (this.isConnected) this.initialize(); }); }
  disconnectedCallback() { this.cleanup?.(); }
  initialize() {
  const root = this.closest('.shopify-section');
  const slider = root.querySelector('slideshow-element');
  if (!slider) return;
  if (root.gradientCleanup) root.gradientCleanup();
  const layers = Array.from(root.querySelectorAll('.slide-gradient-layer'));
  const header = document.querySelector('.header-section');
  const extendHeader = this.dataset.extendHeader === 'true';
  const headerSurface = header?.querySelector(':scope > header');
  if (extendHeader && headerSurface && typeof headerSurface.init === 'function') headerSurface.init();
  let headerBackdrop = null;
  if (headerSurface && extendHeader) {
    headerBackdrop = document.createElement('div');
    headerBackdrop.className = 'slide-gradient-header-backdrop';
    headerBackdrop.setAttribute('aria-hidden', 'true');
    headerBackdrop.style.cssText = 'display:block;opacity:1;position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:-1;transition:opacity 300ms ease';
    layers.forEach(layer => {
      const copy = layer.cloneNode(true);
      copy.style.cssText += ';display:block!important;position:absolute;inset:0;transition:opacity 650ms ease';
      headerBackdrop.appendChild(copy);
    });
    headerSurface.prepend(headerBackdrop);
  }
  let frame = 0;
  let extension = 0;
  let previousGradientIndex = 0;
  const gradientBackdrop = root.querySelector('.slide-gradient-backdrop');
  const select = (index) => {
    const current = Number(index);
    if (!Number.isInteger(current) || current < 0 || current >= layers.length) return;
    const baseGradient = layers[previousGradientIndex]?.style.background || layers[current].style.background;
    if (gradientBackdrop) gradientBackdrop.style.background = baseGradient;
    if (headerBackdrop) {
      headerBackdrop.style.background = baseGradient;
      const referenceLayer = headerBackdrop.firstElementChild;
      if (referenceLayer) {
        headerBackdrop.style.backgroundSize = referenceLayer.style.backgroundSize;
        headerBackdrop.style.backgroundPosition = referenceLayer.style.backgroundPosition;
        headerBackdrop.style.backgroundRepeat = 'no-repeat';
      }
    }
    previousGradientIndex = current;
    layers.forEach((layer, i) => layer.classList.toggle('is-active', i === current));
    if (headerBackdrop) Array.from(headerBackdrop.children).forEach((layer, i) => { layer.style.opacity = i === current ? '1' : '0'; });
  };
  const updateHeader = () => {
    frame = 0;
    if (!header || !extendHeader) return;
    const r = root.getBoundingClientRect();
    const headerHeight = (headerSurface || header).offsetHeight;
    const active = window.scrollY <= 60 && r.bottom > headerHeight;
    header.toggleAttribute('data-slide-gradient-header', active);
    if (headerBackdrop) headerBackdrop.style.opacity = active ? '1' : '0';
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(updateHeader); };
  const measure = () => {
    if (header && extendHeader && window.scrollY < 40) {
      const distance = root.getBoundingClientRect().top - header.getBoundingClientRect().top;
      extension = Math.max(0, distance);
      root.style.setProperty('--gradient-header-extension', extension + 'px');
      if (headerBackdrop) Array.from(headerBackdrop.children).forEach(layer => {
        layer.style.backgroundSize = root.offsetWidth + 'px ' + (root.offsetHeight + extension) + 'px';
        layer.style.backgroundPosition = 'center top';
        layer.style.backgroundRepeat = 'no-repeat';
        headerBackdrop.style.backgroundSize = layer.style.backgroundSize;
        headerBackdrop.style.backgroundPosition = 'center top';
        headerBackdrop.style.backgroundRepeat = 'no-repeat';
      });
    }
    schedule();
  };
  const change = (event) => select(event.detail?.currentPage);
  const blockSelect = (event) => {
    const ids = layers.map(layer => layer.dataset.blockId);
    const index = ids.indexOf(event.detail?.blockId);
    if (index >= 0) select(index);
  };
  const unload = (event) => { if (event.target === root) root.gradientCleanup(); };
  slider.addEventListener('slider:change', change);
  root.addEventListener('shopify:block:select', blockSelect);
  document.addEventListener('shopify:section:unload', unload);
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', measure);
  document.addEventListener('header:scrolled', schedule);
  window.addEventListener('load', measure, { once: true });
  const observer = new ResizeObserver(measure);
  observer.observe(root);
  if (header) observer.observe(header);
  root.gradientCleanup = () => {
    slider.removeEventListener('slider:change', change);
    root.removeEventListener('shopify:block:select', blockSelect);
    document.removeEventListener('shopify:section:unload', unload);
    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', measure);
    document.removeEventListener('header:scrolled', schedule);
    window.removeEventListener('load', measure);
    observer.disconnect();
    cancelAnimationFrame(frame);
    headerBackdrop?.remove();
    if (header) header.removeAttribute('data-slide-gradient-header');
  };
  this.cleanup = root.gradientCleanup;
  select(slider.selectedIndex || 0);
  measure();
  updateHeader();
  }
});
}

  } catch(e) { console.error(e); }
})();
})();
